export function isEuropeanUnion(country: string): boolean {
  return [
    'AT',
    'BE',
    'BG',
    'HR',
    'CY',
    'DK',
    'EE',
    'FI',
    'FR',
    'DE',
    'GR',
    'HU',
    'IE',
    'IT',
    'LV',
    'LT',
    'LU',
    'MT',
    'NL',
    'PL',
    'PT',
    'RO',
    'SK',
    'SI',
    'ES',
    'SE',
    'EU',
    'CZ',
    'GB',
  ].includes(country);
}
